<template>
    <el-dialog
    title="发布课程"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    @open="handleClose"
    width="600px">
    <div class="item">
        <div>开课期数：</div>
        <div>第<span style="color: #387DFF;">{{ periods?periods+1:1 }}</span>期</div>
    </div>
    <div class="item">
        <div>开课时间：</div>
        <el-date-picker
        v-model="form.startTime"
        style="width: 19rem;"
        type="datetime"
        :picker-options="pickerOptions"
        @change="changeTime"
        placeholder="选择开课日期">
        </el-date-picker>
        <div style="padding: 0 1rem;">至</div>
        <el-date-picker
        v-model="form.endTime"
        style="width: 19rem;"
        type="datetime"
        @change="changeTime"
        :picker-options="pickerOptions"
        placeholder="选择结课日期">
        </el-date-picker>
    </div>
    <div class="item">
        <div>本期学分：</div>
        <el-input v-model="form.credit" type="number" style="width: 19rem;" placeholder="请输入学分"></el-input>
    </div>
    <div class="item" style="margin-bottom: 0;">
        <div>学习权限：</div>
        <el-radio-group v-model="form.openType">
            <el-radio :label="0">本校平台</el-radio>
            <el-radio :label="1">全平台</el-radio>
        </el-radio-group>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取 消</el-button>
        <el-button style="margin-left: 3.5rem;" type="primary" @click="publish">发 布</el-button>
    </div>
    </el-dialog>
</template>

<script>
import { ReleaseCourse } from '@/api/course';
import {getDateTime} from '@/utils/utils';
    export default {
        data(){
            return {
                dialogVisible:false,
                id:'',
                operation:'',
                periods:0,
                form:{
                    "credit": 1,
                    "startTime":'',
                    "endTime":'',
                    "openType": 0,
                },
                pickerOptions:{
                    disabledDate(time){
                        return time.getTime() < Date.now();
                    },
                }
            }
        },
        methods:{
            handleClose(){
                this.form={
                    "credit": 1,
                    "startTime":'',
                    "endTime":'',
                    "openType":0,
                };
            },
            changeTime(e){
                let time=new Date(e).getTime() ;
                let now=new Date().getTime();
                if(time<=now){
                    this.form.startTime=time+5*60*1000;
                }
            },
            publish(){
                var params={
                "courseId": this.id,
                "endTime": this.form.endTime?getDateTime(new Date(this.form.endTime).getTime()):null,
                "scope": this.form.openType,
                "score": Number(this.form.credit),
                "startTime": this.form.startTime?getDateTime(new Date(this.form.startTime).getTime()):null
                }
                ReleaseCourse(params).then(res=>{
                    if(res.code==200){
                        this.$msg({
                            showClose: true,
                            message: "发布成功",
                            type: "success",
                        });
                        this.$emit('publish_success');
                        this.dialogVisible=false;
                    }
                })
            }
        },
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog{
    border-radius: 1rem;
}
/deep/.el-dialog__title{
    font-size: 16px;
    font-weight: 700;
    color: #334681;
}
/deep/.el-dialog__header{
    padding-top: 4rem;
    padding-left: 4rem;
    padding-right: 4rem;
}
/deep/.el-dialog__body{
    padding-left: 4rem;
    padding-right: 4rem;
}
/deep/.el-dialog__footer{
    padding-left: 4rem;
    padding-right: 4rem;
}
.item{
    display: flex;
    align-items: center;
    margin-bottom:3rem;
    &> :nth-child(1){
        color: #8590B3;
        font-size: 14px;
    }
}
.dialog-footer{
    text-align: center;
    padding-bottom: 2.5rem;
}
</style>